// ============================================
// Mention Utilities
// Shared helpers for @-mention tagging
// ============================================

/**
 * Convert storage format to display format
 * @[Laurian Detiffe](uuid) → @Laurian Detiffe
 */
export const toDisplayFormat = (text: string): string => {
  return text.replace(/@\[([^\]]+)\]\([^)]+\)/g, '@$1');
};

/**
 * Convert display format back to storage format using a mapping
 * @Laurian Detiffe → @[Laurian Detiffe](uuid)
 */
export const toStorageFormat = (
  displayText: string,
  mentionMap: Map<string, string>
): string => {
  let result = displayText;
  // Sort by length descending to replace longer names first
  const sortedNames = Array.from(mentionMap.keys()).sort(
    (a, b) => b.length - a.length
  );
  for (const displayName of sortedNames) {
    const storageFormat = mentionMap.get(displayName)!;
    const regex = new RegExp(
      `@${displayName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?![\\w])`,
      'g'
    );
    result = result.replace(regex, storageFormat);
  }
  return result;
};

/**
 * Extract all mentioned user UUIDs from storage-format text
 * @[Name](uuid) → ['uuid', ...]
 */
export const extractMentionedUserIds = (storageText: string): string[] => {
  const ids: string[] = [];
  const regex = /@\[[^\]]+\]\(([^)]+)\)/g;
  let match;
  while ((match = regex.exec(storageText)) !== null) {
    ids.push(match[1]);
  }
  return ids;
};

/**
 * Check if display-format text contains any @mentions
 */
export const hasMentions = (displayText: string, mentionMap: Map<string, string>): boolean => {
  if (mentionMap.size === 0) return false;
  for (const displayName of mentionMap.keys()) {
    const regex = new RegExp(
      `@${displayName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?![\\w])`
    );
    if (regex.test(displayText)) return true;
  }
  return false;
};
